// email regex borrowed from https://colinhacks.com/essays/reasonable-email-regex
const emailRegex =
  /^([A-Z0-9_+-]+\.?)*[A-Z0-9_+-]@([A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/i

// split emails by comma, trim whitespace, and remove empty strings
export const parseEmails = (emails: string) => {
  const splitEmails = emails.split(/[;,]/) // Split on comma or semicolon
  return splitEmails
    .map((email: string) => email.trim())
    .filter((email) => email !== '')
}

export const findInvalidEmails = (emails: string[]) =>
  emails.filter((splitEmail: string) => !emailRegex.test(splitEmail))
